import React, { useState, useEffect } from 'react';
import { host } from "../../config/Config";
import "./style/style-pc.css"
import "./style/style-mob.css"
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CloseIcon from '@mui/icons-material/Close';

export const Prices = () => {
    const translationMap = {
        "DODATNO PRANJE KOSE" : "EXTRA HAIR WASH",
        "SKIDANJE BRADE" : "BEARD REMOVAL",
        "BRADA CLASSIC SREDNJA" : "BEARD CLASSIC MID",
        "BRADA CLASSIC DUGAČKA" : "BEARD CLASSIC LONG",
        "CLASSIC NULERICA" : "CLASSIC ZERO",
        "CLASSIC KRATKA KOSA" : "CLASSIC SHORT HAIR",
        "CLASSIC DUŽA KOSA" : "CLASSIC LONG HAIR"
    }
    const [highlightedHaircuts, setHighlightedHaircuts] = useState([]);
    const [otherHaircuts, setOtherHaircuts] = useState([]);
    const [language, setLanguage] = useState("10"); // Default to "10" (Srpski)
    const [showMore, setShowMore] = useState(false);
    const handleClick = () => {
        setShowMore(!showMore);
    }
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [newExpandedIndex, setNewExpandedIndex] = useState(null);

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const toggleNewExpand = (index) => {
        setNewExpandedIndex(newExpandedIndex === index ? null : index);
    }

    const getImageUrl = (name) => {
        try {
            return require(`../../resources/${name}.jpg`);
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        const storedLanguage = localStorage.getItem("selectedLanguage");
        if (storedLanguage) {
            setLanguage(storedLanguage);
        }

        const handleStorageChange = () => {
            setLanguage(localStorage.getItem("selectedLanguage") || "10");
        };

        window.addEventListener("storage", handleStorageChange);

        let isMounted = true;
    
        fetch(`${host}/api/v1/haircuts`)
            .then((response) => response.json())
            .then((data) => {
                if (isMounted) {
                    const highlightedItems = data.filter((item) => item.highlighted === true);
                    const otherItems = data.filter((item) => item.highlighted === false);
    
                    setHighlightedHaircuts(highlightedItems);
                    setOtherHaircuts(otherItems);
                }
            })
            .catch((error) => console.error('Error fetching prices:', error));
    
        return () => {
            isMounted = false;
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div>
            <div className='barbershop-zajednica-prices-title'>
                <h1>{language == 20 ? 'Haircuts and Prices' : 'Cenovnik'}</h1>
            </div>

            {highlightedHaircuts.map((item, index) => {
                const translatedName = language == 20 ? (translationMap[item.name] || item.name) : item.name;
                const imageUrl = getImageUrl(item.name.toLowerCase());

                return (
                    <div className='barbershop-zajednica-prices-items' key={index}>
                        <div className='barbershop-zajednica-prices-item'>
                            <h2>{translatedName}</h2>
                            <h3>{item.price} RSD</h3>
                            <div style={{ position: "relative"}} onClick={() => toggleExpand(index)}>
                                {expandedIndex === index ? 
                                ( <CloseIcon style={{ color: "white", fontSize: "35px" }} />) : 
                                ( <ArrowDownwardIcon style={{ color: "white", fontSize: "35px" }} />)}
                            </div>
                            <div className='barbershop-zajednica-prices-item-underline' />
                        </div>
                        {expandedIndex === index && imageUrl && (
                            <div className='expanded-section' style={{
                                transition: "max-height 0.5s ease-in-out, opacity 0.5s ease-in-out",
                                overflow: "hidden",
                                maxHeight: "500px",
                                opacity: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <img src={imageUrl} alt={translatedName} style={{ width: "100%", height: "auto", marginTop: "10px", display: "block", textAlign: "center" }} />
                            </div>
                        )}
                    </div>
                );
            })}

            {
                showMore ? 
                otherHaircuts.map((item, index) => {
                    const translatedName = language == 20 ? (translationMap[item.name] || item.name) : item.name;
                    const imageUrl = getImageUrl(item.name.toLowerCase());
    
                    return (
                        <div className='barbershop-zajednica-prices-items' key={index}>
                            <div className='barbershop-zajednica-prices-item'>
                                <h2>{translatedName}</h2>
                                <h3>{item.price} RSD</h3>
                                <div style={{ position: "relative", cursor: "pointer" }} onClick={() => toggleNewExpand(index)}>
                                    {newExpandedIndex === index ? 
                                    ( <CloseIcon style={{ color: "white", fontSize: "35px" }} />) : 
                                    ( <ArrowDownwardIcon style={{ color: "white", fontSize: "35px" }} />)}                                </div>
                                <div className='barbershop-zajednica-prices-item-underline' />
                            </div>
                            {newExpandedIndex === index && imageUrl && (
                            <div className='expanded-section' style={{
                                    transition: "max-height 0.5s ease-in-out, opacity 0.5s ease-in-out",
                                    overflow: "hidden",
                                    maxHeight: "500px",
                                    opacity: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <img src={imageUrl} alt={translatedName} style={{ width: "100%", height: "auto", marginTop: "10px", display: "block", textAlign: "center" }} />
                            </div>
                            )}
                        </div>
                    );
                    }) :
                    <div className='barbershop-zajednica-prices-all-items'>
                        <div 
                            className='barbershop-zajednica-prices-button' 
                            onClick={handleClick}>
                            { !showMore && <p>{language == 10 ? 'Prikaži sve frizure' : 'Show more haircuts'}</p> }
                        </div>
                    </div>
            }
            {
                showMore && <div className='barbershop-zajednica-prices-bottom' />
            }
        </div>
    );
}
